import * as Action from "@actions/index";

const InitialState = {
  current: 0,
};

export default function Time(state = InitialState, action: any) {
  switch (action.type) {
    case Action.Main.Time.SET_CURRENT:
      return { ...state, current: action.data };
    default:
      return state;
  }
}
